<template>
  <jade-button
    icon="action-download"
    :size="size"
    :disabled="disabled"
    :loading="report.loading"
    @click="sendReportFile"
    >{{ $t('report.download') }}</jade-button
  >
</template>
<script>
import { mapGetters } from 'vuex'
import { JadeButton } from '@/components/jade'
import sendEvent from '@utils/analiticaEventCaller.utils'

const MAX_ITEMS_PER_REPORT = 150000

const REPORT_ALERT_VARIANTS = {
  sucess: {
    variant: 'success',
    title: 'report.success'
  },
  error: {
    variant: 'danger',
    title: 'report.error'
  },
  limit: {
    variant: 'danger',
    title: 'report.limit'
  }
}

export default {
  name: 'ReportButton',
  components: {
    JadeButton
  },
  props: {
    loadingList: {
      type: Boolean,
      default: false
    },
    report: {
      type: Object,
      required: true
    },
    totalListItems: {
      type: Number,
      required: false
    },
    size: {
      type: String,
      default: 'small'
    },
    eventProps: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters(['merchantId', 'accountId']),
    disabled () {
      return (
        this.totalListItems === 0 || this.report.loading || this.loadingList
      )
    }
  },
  methods: {
    eventCaller () {
      if (
        !this.eventProps?.amplitudeInstance ||
        !this.eventProps?.eventFunctionName
      )
        return

      sendEvent({
        instanceName: this.eventProps.amplitudeInstance,
        featureName: 'actions',
        functionName: this.eventProps.eventFunctionName
      })
    },
    formatQueryToReport () {
      const queryObject = Object.assign({}, this.$route.query)
      this.report.queryArray.map(value => {
        if (value in queryObject) {
          queryObject[value] = Array.isArray(queryObject[value])
            ? queryObject[value]
            : [queryObject[value]]
        }
      })
      return queryObject
    },
    sendReportFile () {
      this.eventCaller()

      if (this.$listeners.callback) {
        return this.$emit('callback')
      }

      if (this.disabled) return

      if (this.totalListItems > MAX_ITEMS_PER_REPORT) {
        this.report.loading = false
        this.report.alert = {
          show: true,
          ...REPORT_ALERT_VARIANTS.limit
        }
      }

      this.report.limitExceeded = false
      this.report.loading = true
      const body = this.formatQueryToReport()
      this.$store
        .dispatch(this.report.action, {
          merchantId: this.merchantId,
          accountId: this.accountId,
          body: body
        })
        .then(() => {
          this.report.loading = false
          this.report.alert = {
            show: true,
            ...REPORT_ALERT_VARIANTS.sucess
          }
        })
        .catch(() => {
          this.report.loading = false
          this.report.alert = {
            show: true,
            ...REPORT_ALERT_VARIANTS.error
          }
        })
    }
  }
}
</script>
<i18n>
{
  "pt-BR": {
    "report.download": "Baixar relatório"
  },
  "en-US": {
    "report.download": "Export report"
  }
}
</i18n>
